(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("casper-js-sdk"));
	else if(typeof define === 'function' && define.amd)
		define(["casper-js-sdk"], factory);
	else if(typeof exports === 'object')
		exports["@casperholders/core"] = factory(require("casper-js-sdk"));
	else
		root["@casperholders/core"] = factory(root["casper-js-sdk"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__647__) => {
return 